export default __webpack_public_path__ + "static/media/oportunitiesTitle.6a26c614.png";